import { Header } from 'antd/es/layout/layout';
import { Button, notification, theme, Tour } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import type { GetRef, TourProps } from 'antd';

import { useEffect, useRef, useState } from 'react';

import style from './HomeHeaderBar.module.css';
import { useTranslation } from 'react-i18next';

import { BarsOutlined } from '@ant-design/icons';
import { TourHelper } from '../../Helpers/TourHelper';
const { useToken } = theme;

const HomeHeaderBar = (props: {
  startTour: boolean;
  SetTourFinished: Function;
}) => {
  let navigate = useNavigate();

  const { i18n, t } = useTranslation();
  const { token } = useToken();
  const [api, contextHolder] = notification.useNotification();

  const refStep1 = useRef<any>(null);
  const refStep2 = useRef<any>(null);
  const refStep3 = useRef<any>(null);
  const refStep4 = useRef<any>(null);

  const steps: TourProps['steps'] = [
    TourHelper.CreateTourSteps(
      t,
      'Afbeelding kolom',
      'Hier wordt het type van de melding getoond. Je kunt deze afbeelding naar wens aanpassen in de instellingen.',
      'top',
      refStep1.current,
    ),
    TourHelper.CreateTourSteps(
      t,
      'Machine kolom',
      'Hier wordt de naam van de machine getoond',
      'top',
      refStep2.current,
    ),
    TourHelper.CreateTourSteps(
      t,
      'Melding kolom',
      'Hier wordt de melding getoond',
      'top',
      refStep3.current,
    ),
    TourHelper.CreateTourSteps(
      t,
      'Instellingen webportaal',
      'Hier kun je de instellingen van het systeem vinden',
      'left',
      refStep4.current,
    ),
  ];

  const NavigateToDevices = () => {
    navigate('/devices');
  };

  useEffect(() => {
    if (props.startTour) {
    }
  }, [props.startTour]);

  return (
    <>
      <Tour
        open={props.startTour}
        onClose={() => props.SetTourFinished()}
        steps={steps}
      />

      <div
        style={{ backgroundColor: token.colorPrimaryBg }}
        className={style.columnNames}
      >
        <div ref={refStep1} className={style.columnSpace}></div>
        <div ref={refStep2} className={style.columnMachine}>
          {t('machine')}
        </div>
        <div ref={refStep3} className={style.columnMessage}>
          {t('message')}
        </div>
        <div className={style.columnSetting}>
          <Button
            ref={refStep4}
            onClick={() => NavigateToDevices()}
            ghost
            style={{ width: 30, height: 30 }}
            icon={
              <BarsOutlined
                className={style.btnSetting}
                style={{ fontSize: 25 }}
              />
            }
          ></Button>
        </div>
      </div>
    </>
  );
};

export default HomeHeaderBar;
